import { HistoryOrder } from '@lib/types';

import { client } from './client';
import { endpoints } from './endpoints';

export async function fetchHistoryOrderDetails(
  orderUUID: string,
): Promise<HistoryOrder> {
  const response = await client.get(endpoints.ORDER_DETAILS(orderUUID));

  return response.data;
}
